<template>
  <div v-if="chart !=''"  style="background-color: #FFFFFF;padding: 10px;border-radius: 5px">
    <div style="margin: 5px;">
      <b-form-group>
        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="optionConfigure.yName"
          :options="yName"
        ></b-form-checkbox-group>
      </b-form-group>
    </div>
    <div style="display: inline-block;width: 100%;margin: 5px;">
      <!--    图表类型选择器    -->
      <b-form-select
        style="max-width: 200px;width: 200px;margin-right: 5px"
        v-model="optionConfigure.chartType"
        :options="options"
      ></b-form-select>
      <!--    饼状图时间选择器    -->
      <b-form-select
        style="max-width: 200px;width: 200px;margin-right: 5px"
        v-model="optionConfigure.xIndex"
        v-if="optionConfigure.chartType=='horizontalPie'"
      >
        <template v-for="(data,index) in optionSet.dataArray">
          <option :key="index" :value="index">{{$t(data[optionSet.xName])}}</option>
        </template>
      </b-form-select>
      <!--        </div>-->
    </div>
    <div style="margin: 5px;" :style="{height:height,width:width}" id="chartBody"></div>
  </div>
</template>

<script>
import defaultOptions from "./chartOption.json";
export default {
  name: "echart",
  props: {
  
    rows: {
      type: Array 
    },
    entity: {
      type: String
    },
    //图表宽度设置
    width: {
      type: String,
      default: "100%"
    },
    //图表高度设置
    height: {
      type: String,
      default: "600px"
    }
  },
  data() {
    return {
      options: [
        {
          value: "verticalLine",
          text: "纵向折线图"
        },
        {
          value: "verticalPie",
          text: "纵向分析饼"
        },
        {
          value: "horizontalPie",
          text: "横向分析饼"
        },
        {
          value: "verticalBar",
          text: "垂直柱"
        },
        {
          value: "horizontalBar",
          text: "水平柱"
        }
      ],
      optionConfigure: {
        chartType: "verticalPie"
      },
      optionSet:[],
      yName: [],
      yNameMap: {},
      xNameMap: {},
      chart:""
    };
  },
  methods: {
    drawChart() {
      let chartType = this.optionConfigure.chartType;
      if (chartType == "verticalBar" || chartType == "verticalLine")
        this.drawVerticalChart();
      else if (chartType == "horizontalBar" || chartType == "horizontalLine")
        this.drawHorizontalChart();
      else if (chartType == "horizontalPie" || chartType == "verticalPie")
        this.drawPieChart();
    },
    //绘制垂直柱、折图
    drawVerticalChart() {
      this.setTitle();
      this.setLegendData();
      this.setXAxis();
      this.setSeries();
      this.drawChartChange();
    },
    //绘制水平柱、折图
    drawHorizontalChart() {
      this.setTitle();
      this.setLegendData();
      this.setYAxis();
      this.setSeries();
      this.drawChartChange();
    },
    //绘制饼图
    drawPieChart() {
      this.setTitle();
      this.setLegendData();
      this.setSeries();
      this.drawChartChange();
    },
    drawChartChange() {
      var myChart = this.$echarts.init(document.getElementById("chartBody"));
      myChart.clear();
      myChart.setOption(this.option);
    },
    setTitle() {
      this.option.title.text = this.optionConfigure.title;
    },
    setLegendData() {
      switch (this.optionConfigure.chartType) {
        case "verticalPie": {
          let data = [];
          for (let i of this.optionConfigure.dataArray) {
            data.push(i[this.optionConfigure.xName]);
          }
          this.option.legend.data = data;
          break;
        }
        default: {
          this.option.legend.data = this.optionConfigure.yName;
        }
      }
    },
    setXAxis() {
      this.option.xAxis.data = this.optionConfigure.dataArray.map(
        v => v[this.optionConfigure.xName]
      );
    },
    setYAxis() {
      this.option.yAxis.data = this.optionConfigure.dataArray.map(
        v => v[this.optionConfigure.xName]
      );
    },
    setSeries() {
      switch (this.optionConfigure.chartType) {
        case "verticalPie": {
          this.option.series[0].name = this.optionConfigure.title;
          let array = [];
          let data = this.optionConfigure.dataArray;
          for (let i of data) {
            let num = 0;
            for (let j of this.optionConfigure.yName) {
              if (typeof i[j] != "number") console.log("typeof error");
              num += i[j];
            }
            array.push({
              name: i[this.optionConfigure.xName],
              value: num
            });
          }
          this.option.series[0].data = array;
          break;
        }
        case "horizontalPie": {
          this.option.series[0].name = this.optionConfigure.title;
          let ob =
            typeof this.optionConfigure.dataArray[
              this.optionConfigure.xIndex
            ] == "undefined"
              ? this.optionConfigure.dataArray[0]
              : this.optionConfigure.dataArray[this.optionConfigure.xIndex];
          let array = [];
          for (let i in ob) {
            if (
              this.optionConfigure.yName.some(item => {
                return item == i;
              })
            )
              array.push({
                name: i,
                value: ob[i]
              });
          }
          this.option.series[0].data = array;
          break;
        }
        default: {
          let series = [];
          for (let i of this.optionConfigure.yName) {
            let seriesItem = JSON.parse(
              JSON.stringify(
                defaultOptions[this.optionConfigure.chartType].series[0]
              )
            );
            console.log(seriesItem);
            seriesItem.name = i;
            seriesItem.data = this.optionConfigure.dataArray.map(v => v[i]);
            series.push(seriesItem);
          }
          this.option.series = series;
        }
      }
    },
    setOption(){
        let nameMap = Object.assign({}, this.xNameMap, this.yNameMap);
           this.optionSet = {
            dataArray:this.rows.map(row => {
                return Object.keys(nameMap).reduce((prev,key)=>{
                    prev[nameMap[key]] = row[key]
                    return prev
                },{})
            }),
            xName:Object.keys(this.xNameMap).map(name=>this.xNameMap[name]),
            xIndex:'0',
            yName:Object.keys(this.yNameMap).map(name=>this.yNameMap[name]),
            chartType:'verticalLine',
            // title:'Energy Cost'
        }
    },
    findChart(){
    return this.$store
                .dispatch("api/get", {
                    url:
                        process.env.VUE_APP_ADM_API_URL +
                        "adm-service/adm" +
                        "/chart/findChart" +
                        "?" +
                        "name=" +
                        this.entity
                })
                .then(response => {
                    this.chart = response;
                });
  },
  setNameMap(){
      this.xNameMap[this.chart.xAttribute]=this.chart.xName;
      for(var i=0; i<this.chart.chartItems.length;i++){
          this.yNameMap[this.chart.chartItems[i].yAttribute]=this.chart.chartItems[i].yName;
      }

      
  }
  },
  computed: {},
  watch: {
    optionConfigure: {
      handler(val) {
          
        this.option = JSON.parse(JSON.stringify(defaultOptions[val.chartType]));
        console.log(typeof val.dataArray);
        this.drawChart();
      },
      deep: true
    },
    // optionSet: {
    //   handler(val) {
    //     this.yName = JSON.parse(JSON.stringify(this.optionSet.yName));
    //     this.optionConfigure = JSON.parse(JSON.stringify(val));
    //   },
    //   deep: true
    // },
      rows: {
      handler(val) {
          if(this.chart!=""){
              this.setNameMap()
          this.setOption();
    this.optionConfigure = JSON.parse(JSON.stringify(this.optionSet));
    this.yName = JSON.parse(JSON.stringify(this.optionSet.yName));
          }
          
      },
      deep: true
    }
  },
  mounted() {
  //todo 暂时屏蔽，因为停用了mmf-adm
    // this.findChart().then(()=>{
    //     if(this.chart!=""){
    //       this.setNameMap()
    //       this.setOption();
    // this.optionConfigure = JSON.parse(JSON.stringify(this.optionSet));
    // this.yName = JSON.parse(JSON.stringify(this.optionSet.yName));
    //     }
    // });
   
  }
};
</script>
